import { formatMoney, type Money } from "@stb/core/money"

/** "A$2,912.00": core/money formatting with the AUD marker the design uses. */
export const formatAud = (value: Money): string => formatMoney(value, "en-AU").replace("$", "A$")
